import type { RiskGapResource, RiskGapType } from '@ctw/shared/api/snowflake/risk-gaps';
import { format } from 'date-fns';
import { FHIRModel } from './fhir-model';

export class RiskGapModel extends FHIRModel<RiskGapResource> {
  public kind = 'RiskGap' as const;
  private static readonly HCC_CODE_REGEX = /^(.*HCC)?/;

  public get key(): string {
    return this.id;
  }

  public get title(): string {
    return this.resource.label;
  }

  public get rafScore(): number {
    return this.resource.coefficient;
  }

  public get rafScoreDisplay(): string {
    return this.rafScore.toFixed(3);
  }

  public get hccCode(): number {
    return Number.parseInt(this.resource.qualifiedFactor.replace(RiskGapModel.HCC_CODE_REGEX, ''));
  }

  public get type(): RiskGapType {
    return this.resource.type;
  }

  public get lastDiagnosedDisplay(): string | undefined {
    const { latestRecordedDate } = this.resource;
    if (latestRecordedDate) {
      return format(new Date(latestRecordedDate), 'MM/yyyy');
    }
    return undefined;
  }

  public get confidenceLevel(): number | null {
    return this.resource.confidenceLevel;
  }

  public get confidenceRating(): 'low' | 'medium' | 'high' | undefined {
    switch (this.confidenceLevel) {
      case 1:
      case 2:
        return 'low';
      case 3:
      case 4:
        return 'medium';
      case 5:
        return 'high';
      default:
        return undefined;
    }
  }
}
